// @flow

import { Link } from 'react-router-dom';

import { selectHelpdeskUrl } from '@gandi/authentication';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

export function SupportLink(): React.MixedElement {
  const { __ } = useTranslator();

  const supportURL = useAppSelector(selectHelpdeskUrl);

  return <Link to={supportURL}>{__('contact the Customer Care')}</Link>;
}
